import { createTestIds } from '../../utils';

export const getSpeechToTextButtonTestIds = createTestIds('speech-to-text-button', [] as const);
